import { Box, Step, StepLabel, Stepper, useTheme } from "@mui/material";
import React, { useContext } from "react";
import { PAGES } from "utils/constants";
import { PageContext } from "utils/PageContext";
import { UserContext } from "utils/UserContext";

function Header() {
  const { page } = useContext(PageContext);
  const { currentStep } = useContext(UserContext);

  const mainTheme = useTheme();

  const pageNames = Object.values(PAGES);

  return (
    <Box
      component="header"
      sx={{
        position: "fixed",
        top: 0,
        right: 0,
        left: 0,
        zIndex: 2,
        height: page !== PAGES.HOME && 120,
        bgcolor: mainTheme.palette.blackPrimary.main,
        paddingTop: page !== PAGES.HOME && "1.5rem",
      }}
    >
      {page !== PAGES.HOME && (
        <Stepper alternativeLabel activeStep={currentStep}>
          {pageNames.map((pageName) =>
            pageName !== "Home" ? (
              <Step key={pageName}>
                <StepLabel>{pageName}</StepLabel>
              </Step>
            ) : null
          )}
        </Stepper>
      )}
    </Box>
  );
}

export default Header;
